import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const AlarmOffIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9999 5.99999C15.8699 5.99999 18.9999 9.12999 18.9999 13C18.9999 13.84 18.8399 14.65 18.5699 15.4L20.0899 16.92C20.6699 15.73 20.9999 14.41 20.9999 13C20.9999 8.02999 16.9699 3.99999 11.9999 3.99999C10.5899 3.99999 9.2699 4.32999 8.0799 4.90999L9.5999 6.42999C10.3499 6.15999 11.1599 5.99999 11.9999 5.99999ZM21.9999 5.71999L17.3999 1.85999L16.1099 3.38999L20.7099 7.24999L21.9999 5.71999ZM2.9199 2.28999L1.6499 3.56999L2.9799 4.89999L1.8699 5.82999L3.2899 7.24999L4.3999 6.30999L5.1999 7.10999C3.8299 8.68999 2.9999 10.75 2.9999 13C2.9999 17.97 7.0199 22 11.9999 22C14.2499 22 16.3099 21.17 17.8899 19.8L20.0899 22L21.3599 20.73L3.8899 3.26999L2.9199 2.28999ZM16.4699 18.39C15.2599 19.39 13.6999 20 11.9999 20C8.1299 20 4.9999 16.87 4.9999 13C4.9999 11.3 5.6099 9.73998 6.6099 8.52998L16.4699 18.39ZM8.0199 3.27999L6.5999 1.85999L5.7399 2.56999L7.1599 3.98999L8.0199 3.27999V3.27999Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
